import apiRequest from './apiRequest';

type Response = {
  mediaUploadURL: string;
  jobID: string;
};

type Payload = {
  extension: string;
  jobID?: string;
  mediaID?: string;
  projectID?: string;
  wsConnectionID: string;
  wsHttpEndpoint: string;
};

export default async function postJobsMediaUploadLink(payload: Payload) {
  return await apiRequest<Response>(
    'mogen-orchestration',
    `/jobs/media/uploadLink`,
    {
      method: 'POST',
      body: JSON.stringify(payload),
    },
  );
}
